var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_736_14740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.39999 2.40005H8.79999V0.800049H2.39999C1.97564 0.800049 1.56868 0.96862 1.26862 1.26868C0.968559 1.56874 0.799988 1.9757 0.799988 2.40005V13.6C0.799988 14.0244 0.968559 14.4314 1.26862 14.7314C1.56868 15.0315 1.97564 15.2 2.39999 15.2H8.79999V13.6H2.39999V2.40005Z",
    fill: "white",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4 4V7.2H4V8.8H10.4V12L15.2 8L10.4 4Z",
    fill: "white",
    fillOpacity: 0.87
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_736_14740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/SignOut.1ac0cc4bedb6a096aae612a43be2100a.svg";
export { ForwardRef as ReactComponent };